// Payment stage enumeration
export enum PaymentStage {
  PAY = 1,
  CONFIRM = 2,
  COMPLETE = 3,
}

// Payment order model
export interface PaymentOrder {
  id: number;
  po_number: string;
  total_cost: number;
  order_placement_date: string;
  actual_delivery_date: string;
  payment_status_id: number;
  status_id: number;
  store_name: string;
  store_id: number;
  supplier_id: number;
  supplier_name: string;
  payment_status: string;
  payment_stage_id: number | null;
  payment_proof_image: string | null;
  payment_proof_uploaded_at: string | null;
  official_receipt_image: string | null;
  confirmed_at: string | null;
  payment_stage_name: string | null;
  payment_batch_id: number | null;
  batch_code: string | null;
  batch_order_count: number | null;
  batch_total_amount: number | null;
}

// Supplier payment details model
export interface SupplierPaymentDetails {
  id: number;
  supplier_company_id: number;
  bank_name: string | null;
  account_name: string | null;
  account_number: string | null;
  qr_code_image: string | null;
  payment_instructions: string | null;
}

// Order payment details model
export interface OrderPaymentDetails {
  id: number;
  order_id: number;
  payment_stage_id: number;
  payment_proof_image: string | null;
  payment_proof_uploaded_at: string | null;
  payment_remarks: string | null;
  official_receipt_image: string | null;
  official_receipt_uploaded_at: string | null;
  confirmation_remarks: string | null;
  confirmed_at: string | null;
  rejected_at: string | null;
  rejection_reason: string | null;
  stage_name: string;
  stage_code: string;
  uploaded_by_name: string | null;
  confirmed_by_name: string | null;
}

// Payment history item from tracking logs
export interface PaymentHistoryItem {
  title: string;
  description: string;
  datetime: string;
  first_name: string;
  last_name: string;
}

export interface PaymentPagination {
  total_rows: number;
  per_page: number;
}

export interface GetPaymentOrdersResponse {
  orders: PaymentOrder[];
  tab: number[];
  pagination: PaymentPagination;
}

export interface GetOrderPaymentDetailsResponse {
  order: any;
  payment: OrderPaymentDetails | null;
  supplier_payment_info: SupplierPaymentDetails | null;
  payment_history: PaymentHistoryItem[];
}

// Payment process tabs configuration
export interface PaymentProcessTab {
  id: number;
  name: string;
  stageCode: string;
}

export interface PaymentBatch {
  id: number;
  batch_code: string;
  total_amount: number;
  order_count: number;
  payment_proof_image: string | null;
  payment_proof_uploaded_at: string | null;
  payment_remarks: string | null;
  official_receipt_image: string | null;
  official_receipt_uploaded_at: string | null;
  confirmation_remarks: string | null;
  confirmed_at: string | null;
  rejected_at: string | null;
  rejection_reason: string | null;
  payment_stage_id: number;
  created_at: string;
}

export interface PaymentBatchOrder {
  id: number;
  po_number: string;
  total_cost: number;
  order_placement_date: string;
  actual_delivery_date: string;
  payment_status_id: number;
  status_id: number;
  store_name: string;
  store_id: number;
  supplier_id: number;
  supplier_name: string;
  payment_stage_id: number;
  payment_batch_id: number;
}

export interface GetPaymentBatchDetailsResponse {
  batch: PaymentBatch;
  orders: PaymentBatchOrder[];
  supplier_payment_info: SupplierPaymentDetails | null;
  payment_history: PaymentHistoryItem[];
}

export const PAYMENT_PROCESS_TABS: PaymentProcessTab[] = [
  { id: 1, name: "Pay", stageCode: "PAY" },
  { id: 2, name: "Confirm Payment", stageCode: "CONFIRM" },
  { id: 3, name: "Complete Payment", stageCode: "COMPLETE" },
];
